import {
	Box,
	Divider,
	Button,
	styled,
	ButtonProps,
	useTheme,
	useMediaQuery,
	DialogContentText,
	DialogActions,
	DialogTitle,
	DialogContent,
	Dialog, Slide, IconButton
} from '@mui/material';
// import {stateToHTML} from 'draft-js-export-html';
// import {convertFromRaw} from 'draft-js';
// import DOMPurify from 'dompurify';
// import ReactHtmlParser from 'react-html-parser';
import bg from './assets/images/m-1/bg-1.webp';
import content from './assets/images/m-1/content.webp';
import desc from './assets/images/m-1/desc.webp';
import gift from './assets/images/m-1/gift.webp';
import gift72m from './assets/images/m-1/gift72m.webp';
import go from './assets/images/m-1/go.webp';
import harekat from './assets/images/m-1/harekat.webp';
import katibe from './assets/images/m-1/katibe.gif';
import {useTranslation} from 'react-i18next';
import React, {forwardRef, useState, ReactElement, Ref} from 'react';
import {ICompetition} from '../../ICompetitions';
import {TransitionProps} from '@mui/material/transitions';
import CloseIcon from '@icons/CloseIcon';
import {Link} from 'react-router-dom';

type IProps = {
	competition: ICompetition,
	referrer: string,
	// referral: string | undefined
}
const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: ReactElement<any, any>;
	},
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props}/>;
});
const ColorButton = styled(Button)<ButtonProps>(({theme}) => ({
	color: theme.palette.getContrastText('rgb(232 190 115)'),
	backgroundColor: 'rgb(232 190 115)',
	'&:hover': {
		backgroundColor: 'rgb(232 190 115)'
	}
}));
export default function MoveCompetition(props: IProps) {
	const {competition, referrer} = props;
	const {t} = useTranslation();
	const [open, setOpen] = useState(false);
	const theme = useTheme();
	const [initialData, setInitialData] = useState('');
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	
	// const getHTMLData = (value: any) => {
	// 	setInitialData(stateToHTML(convertFromRaw(JSON.parse(value))));
	// };
	// useEffect(() => {
	// 	getHTMLData(competition.description);
	// }, []);
	const handleClickOpen = () => {
		setOpen(true);
	};
	
	const handleClose = () => {
		setOpen(false);
	};
	
	// function createMarkup(html: any) {
	// 	return {
	// 		__html: DOMPurify.sanitize(html)
	// 	};
	// }
	
	return (
		<>
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				scroll={'paper'}
				TransitionComponent={Transition}
				keepMounted={true}
				aria-labelledby="responsive-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="responsive-dialog-title">
					{t('competitions.conditions')}
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500]
					}}
				>
					<CloseIcon/>
				</IconButton>
				<DialogContent dividers={true}>
					{/*<DialogContentText dangerouslySetInnerHTML={createMarkup(initialData)}>*/}
					<DialogContentText dangerouslySetInnerHTML={{__html: competition.description as string}}>
						{/*{*/}
						{/*	ReactHtmlParser(initialData)*/}
						{/*}*/}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						{t('competitions.understood')}
					</Button>
				</DialogActions>
			</Dialog>
			<Box className="w-full h-[calc(100vh-55px)] overflow-hidden justify-center align-middle relative"
			     sx={{
				     backgroundImage: `url(${bg})`,
				     backgroundRepeat: 'no-repeat',
				     backgroundSize: 'cover'
			     }}
			>
				<div className="absolute -top-3 left-2 w-20">
					<img src={katibe} alt="katibe"/>
				</div>
				<div className="flex flex-col mx-8 h-full content-center justify-around items-center">
					<div className="flex flex-col w-9/12 justify-center mt-10 gap-y-3">
						<img src={harekat} alt="title"/>
						<img src={desc} alt="returnImage"/>
					</div>
					<Link to={`/move/${competition.id}`} state={{referrer: referrer}}
					      className="w-[48%] scaleAnimate">
						<div className="flex flex-row w-full justify-center">
							<div
								className="flex flex-row w-52 bg-[length:160px_40px] bg-no-repeat bg-right justify-around size-auto"
							>
								<img className="w-auto h-auto" src={go} alt="play"/>
							</div>
						</div>
					</Link>
					{/*	<div>
					 <ColorButton variant="contained" className="rounded-3xl" onClick={handleClickOpen}>
					 {t('competitions.more_info')}
					 </ColorButton>
					 </div>*/}
					{/*<Divider className="h-10"/>*/}
					
					<div className="h-[50%] flex flex-col justify-center items-center content-center align-middle">
						<img className="w-5/6 h-auto" src={gift72m} alt="play"/>
						<img src={gift} alt="gifts" className="mt-8"/>
						<img src={content} alt="giftText" className="mt-3"/>
					</div>
				</div>
			</Box>
		</>
	);
}
